import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { Typography } from "@mui/material";
import { Box, height } from "@mui/system";
import styles from "./PostRequirement.module.css";

const SearchSelectDrawer = ({
  handleClose,
  show,
  selectFilterData,
  selectedJobPost,
  handleShowCandidate,
}) => {
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="bottom"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "34px",
        width: "100%",
        height: "15%",
        padding: "10px 100px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography>
          <b>You have shortlisted 2 profile</b>
        </Typography>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header> */}
      <Offcanvas.Body>
        <Box className={styles.slected_section}>
          <Box>
            <Typography>
              <b>
                You have shortlisted{" "}
                {selectFilterData?.length > 0 ? selectFilterData?.length : 0}{" "}
                profile
              </b>
            </Typography>
            <Typography>
              1 Credit deduct for each shortlist after successfully delivery.
            </Typography>
            <Typography>
              High priority email will deliver in just 2 mins only.{" "}
            </Typography>
          </Box>
          <Box>
            <button
              disabled={selectedJobPost?.length === 0}
              style={
                selectedJobPost?.length === 0 ? { cursor: "not-allowed" } : {}
              }
              onClick={handleShowCandidate}
            >
              Selected (
              {selectedJobPost?.length > 0 ? selectedJobPost?.length : 0})
            </button>
            {/* <button
              style={
                selectedJobPost?.length === 0
                  ? { marginLeft: "10px", cursor: "not-allowed" }
                  : { marginLeft: "10px" }
              }
              onClick={handleOnClickSortList}
              disabled={selectedJobPost?.length === 0}
            >
              Proceed
            </button> */}
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SearchSelectDrawer;
